import getPlanIdWorkoutUtil from '../../../../../modules/workout/model/utils/get-plan-id'
import hasStartedAndNotEndedByIdPlanSelector from '../../../../plans/selectors/has-started-and-not-ended-by-id'
import getCurrentWorkoutSelect from '../get-current'

function isInStartedPlanWorkoutSelector (paramWorkout) {
  return state => {
    const workout = paramWorkout || getCurrentWorkoutSelect(state)
    const planId = getPlanIdWorkoutUtil(workout)
    return hasStartedAndNotEndedByIdPlanSelector(planId)(state)
  }
}

export default isInStartedPlanWorkoutSelector
